import { AfterViewInit, Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DebounceConstants } from './debounce-constants';

@Directive({
   selector: '[debouncedClick]',
})
export class ClickEventDebounceDirective implements AfterViewInit, OnDestroy {
   @Output()
   public debouncedClick: EventEmitter<any> = new EventEmitter<any>();

   @Input()
   public debouncedClickDelay = DebounceConstants.DEFAULT_DEBOUNCE;

   private stream: Subject<any> = new Subject<any>();
   private subscription: Subscription;

   constructor() {}

   ngOnDestroy(): void {
      this.subscription.unsubscribe();
   }

   @HostListener('click', ['$event'])
   public onClick(value: any): void {
      this.stream.next(value);
   }

   ngAfterViewInit(): void {
      this.subscription = this.stream.pipe(debounceTime(this.debouncedClickDelay)).subscribe((value: any) => this.debouncedClick.next(value));
   }
}
